export const data = [
  {
    id: 1,
    title: "Tashkent",
  },
  {
    id: 2,
    title: "Andijan",
  },
  {
    id: 3,
    title: "Namangan",
  },
  {
    id: 4,
    title: "Fergana",
  },
  {
    id: 5,
    title: "Jizzakh",
  },
  {
    id: 6,
    title: "Termez",
  },
  {
    id: 7,
    title: "Navoiy",
  },
  {
    id: 8,
    title: "Qashqadaryo",
  },
  {
    id: 9,
    title: "Sirdaryo",
  },
  {
    id: 10,
    title: "Bukhara",
  },
  {
    id: 11,
    title: "Samarkand",
  },
  {
    id: 12,
    title: "Urgench",
  },
  {
    id: 13,
    title: "Karakalpakstan",
  },
];
